import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_storage_alerts_filtersService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { fullTextSearch?: string, application_name?: string, alert_id?: string, $top?: number, $skip?: number }): Promise<{ result?: { id?: string, application_name?: string, alert_id?: string, filter_name?: string, filter_value?: string }[], totalCount?: number }> {

    let url = `${environment.backendUrl}api/Notifications/datasources/ds_storage_alerts_filters/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, application_name?: string, alert_id?: string, $keys: string[] }): Promise<{ result?: { id?: string, application_name?: string, alert_id?: string, filter_name?: string, filter_value?: string }[] }> {

    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Notifications/datasources/ds_storage_alerts_filters/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
}
